// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:05:31

export default {
  "id": "hexa-sort-winter-edition",
  "slug": "hexa-sort-winter-edition",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8ad7290eb0f34df28e0b6301f8506d59-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8ad7290eb0f34df28e0b6301f8506d59/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hexa Sort: Winter Edition",
      "description": "Step into a mesmerizing world of winter puzzles with Hexa Sort! More than just a game, it’s a journey into a frosty realm where every hexagonal tile sparkles like a snowflake. Match and merge the pieces to create perfect combinations, clearing the way for new challenges as snow crystals gently dissolve.\n",
      "instructions": "How to Play Hexa Sort: Winter Edition\nGoal: Arrange hexagonal tiles to complete lines or specific patterns and clear the board.\nHow to Play: Drag tiles from the bottom of the screen onto the board and place them strategically.\nScoring: Earn points by completing lines or patterns. The more lines cleared at once, the higher the score.\nGame Over: The game ends when there’s no space left for new tiles.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "六角排序：冬日版",
      "description": "踏入令人着迷的冬季拼图世界，体验Hexa Sort！这不仅仅是一款游戏，更是一次踏入冰封领域的旅程。每一个六边形拼图都闪耀着雪花般的光芒。匹配并合并拼图，创造完美组合，随着雪花缓缓消融，为新挑战清出道路。",
      "instructions": "如何玩《六边形排序：冬季版》\n目标：排列六边形瓷砖以完成线条或特定图案，并清空游戏板。\n玩法：将屏幕底部的瓷砖拖动到游戏板上并战略性地放置。\n得分：通过完成线条或图案获得分数。一次性清除的线条越多，得分越高。\n游戏结束：当没有空间放置新瓷砖时，游戏结束。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-TW": {
      "title": "六角排序：冬季版",
      "description": "踏進迷人的冬日拼圖世界，玩Hexa Sort！這不僅僅是一款遊戲，它是一個通往寒冷領域的旅程，每一塊六邊形拼圖都閃耀著如雪花般的光澤。匹配並合併拼圖來創造完美組合，隨著雪晶輕柔地溶解，為新的挑戰開闢道路。",
      "instructions": "如何玩「六角排序：冬季版」：\n目標：將六角形磁磚排列以完成線條或特定圖案，並清空遊戲板。\n遊戲玩法：從螢幕底部拖動磁磚到遊戲板上，並策略性地放置。\n得分：完成線條或圖案可獲得分數。一次清空越多線條，得分越高。\n遊戲結束：當沒有空間放置新磁磚時，遊戲結束。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-HK": {
      "title": "六角排序：冬日版",
      "description": "踏入冬季謎題的迷人世界，享受Hexa Sort！這不僅是一個遊戲，更是一場踏足寒冷王國的旅程。每一塊六邊形的拼圖都像雪花般閃耀。匹配並合併碎片，創造完美的組合，讓新挑戰的雪晶輕柔地溶解，為你開闢道路。",
      "instructions": "如何玩「六角排序：冬日版」\n目標：將六角形磁磚排列以完成線條或特定圖案，並清空遊戲版。\n遊戲方法：將磁磚從螢幕底部拖動到遊戲版上，並策略性地放置。\n得分：通過完成線條或圖案來獲得分數。一次清空越多的線條，得分越高。\n遊戲結束：當沒有空間放置新磁磚時，遊戲結束。",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "1人玩"
      ]
    },
    "ja": {
      "title": "ヘクサソート：ウィンターエディション",
      "description": "ヒクサスオート！で冬の謎解きの魅惑的な世界に足を踏み入れてください。ただのゲームではなく、雪の結晶のように輝く六角形のタイルが詰まった氷冷の領域への旅です。ピースをマッチさせ、組み合わせを創り出し、完璧なコンビネーションを作ることで、新しい挑戦が雪の結晶が優しく溶けるように道を開いていきます。",
      "instructions": "ヘクサソート：ウィンターエディションの遊び方\n目標：六角形のタイルを並べてラインや特定のパターンを完成させ、ボードをクリアする。\n遊び方：スクリーンの下部からタイルをドラッグしてボードに戦略的に配置する。\nスコア：ラインやパターンを完成させるとポイントを獲得する。一度にクリアするラインが多いほどスコアが高くなる。\nゲームオーバー：新しいタイルを配置する空間がなくなったときにゲームが終了する。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "헥사 소트: 워터 에디션",
      "description": "헥사 소트를 통해 동화적인 겨울 퍼즐 세계로 들어오세요! 단순한 게임이 아닌, 얼음의 영역으로의 여행입니다. 각 육각형 타일이 눈송이처럼 빛나는 곳에서, 조각들을 일치시키고 병합하여 완벽한 조합을 만들어 새로운 도전의 길을 열어갑니다. 눈의 결정이 우아하게 녹아서 사라지는 동안 새로운 도전을 이어갑니다.",
      "instructions": "헥사 정렬: 블리자드 에디션 플레이 방법\n목표: 힙사각형 타일을 줄이거나 특정 패턴을 완성하여 보드를 정리합니다.\n플레이 방법: 화면 하단의 타일을 보드에 드래그하여 전략적으로 배치합니다.\n점수: 줄이거나 패턴을 완성하여 점수를 얻습니다. 한 번에 더 많은 줄을 정리할수록 점수가 높아집니다.\n게임 종료: 새 타일을 배치할 공간이 없을 때 게임이 끝납니다.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Hexa Sort : Édition Hiver",
      "description": "Plongez dans un monde fascinant de puzzles d'hiver avec Hexa Sort ! Plus qu'un jeu, c'est un voyage dans un royaume enneigé où chaque tuile hexagonale brille comme une neige. Associationnez et fusionnez les pièces pour créer des combinaisons parfaites, en ouvrant la voie à de nouveaux défis alors que les cristaux de neige fondent doucement.",
      "instructions": "Comment jouer à Hexa Sort : Édition Hiver\nObjectif : Organiser les tuiles hexagonales pour compléter des lignes ou des motifs spécifiques et nettoyer le plateau.\nComment jouer : Faites glisser les tuiles depuis le bas de l'écran vers le plateau et placez-les stratégiquement.\nClassement : Gagnez des points en complétant des lignes ou des motifs. Plus de lignes sont effacées en même temps, plus le score est élevé.\nFin du jeu : Le jeu se termine lorsque plus de place n'est plus disponible pour de nouvelles tuiles.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
